import React from 'react';

import { UserDirectoryPage } from './UserDirectoryPage';

export const PasswordReset: React.FC = () => (
  <UserDirectoryPage
    title="Password Reset Directory"
    actions={[
      // Password-expired always gets a reset button, even once the "password is expired" message is showing.
      {
        when: (status) => status === 'password_expired',
        actionType: 'reset-password',
        label: 'Send password reset email',
        successMessage: (name) => `User "${name}" was successfully sent password reset email!`,
      },
      // Every other non-suspended status: same button, but it hides once a success/info message is showing.
      {
        when: (status) => (status !== 'suspended' && status !== 'provisioned'),
        actionType: 'reset-password',
        label: 'Send password reset email',
        successMessage: (name) => `User "${name}" was successfully sent password reset email!`,
        hideWhileMessageShowing: true,
      },
    ]}
    notices={[
      {
        when: (status) => status === 'suspended',
        message: 'Please unsuspend account before sending Password Reset email',
      },
      {
        when: (status) => status === 'provisioned',
        message: 'User is in Provisioned status. Please send User Activation email if needed on the Account Activation tab.',
      },
    ]}
  />
);

export default PasswordReset;
